import CachedImg from './ui/CachedImg';

/**
 * A photo tile for the Sets and Maps indexes - the Events feed's tile (Sam's A, 2026-10-28), opened by a tap. `corner`
 * sits top right over the photo (your download pill); it is a sibling of the button, so it can be a button itself.
 */
export default function IndexTile({ photo, name, meta, onOpen, corner = null }) {
  return (
    <div className="event-tile index-tile">
      {/* No "last opened" outline: it read as selected (operator, 2026-09-23). */}
      <button type="button" className="event-tile__photo index-tile__open" onClick={onOpen}>
        {photo ? (
          <CachedImg src={photo} alt="" className="event-tile__img" loading="lazy" />
        ) : (
          <span className="event-tile__img event-tile__img--none" aria-hidden />
        )}
        <span className="event-tile__over">
          <span className="event-tile__name">{name}</span>
          {meta && <span className="event-tile__meta">{meta}</span>}
        </span>
      </button>
      {corner && <span className="index-tile__corner">{corner}</span>}
    </div>
  );
}
